export default "__VITE_ASSET__Emk$UmUB__"